const content = {
  heading: "Länna Gård",
  paragraphs: [
    "Bröllopsfesten kommer att stå i Länna Gård, en ombonad lada utanför Uppsala. Vid ankomst bjuds på fördrink och lekar.",
    "Parkering finns i anslutning till byggnaden.",
  ],
};

export default content;
